import CircleIcon from '@mui/icons-material/Circle';
import { IconButton } from '@mui/material';

import Display from 'shared/components/Display';
import { ConnectionStatusT } from 'shared/models/api';
import { PaletteColorsT } from 'shared/models/mui';
import { datePrettyDisplay, formatDateFromNow } from 'utils/date';

interface StatusIconT {
  color: PaletteColorsT;
  label: string;
}

const NEVER_SEEN = 'Never Seen';

const statusCodeToLabel: Record<string, string> = {
  UNKNOWN: 'Never Connected',
  NEVER_CONNECTED: 'Never Connected',
  OK: 'Ok',
  CONNECTED: 'Connected',
  DISCONNECTED: 'Disconnected',
  ERROR: 'Error',
  DEV_STATUS_NEVER_SEEN: 'Never Seen',
  DEV_STATUS_SYNC_ERROR: 'Synchronization Error',
  DEV_STATUS_UL_OK: 'Ok',
  DEV_STATUS_DL_OK: 'Ok',
  DEV_STATUS_IP_PACKETS_UL_ERROR: 'IP Packets Error',
  DEV_STATUS_IP_PACKETS_DL_ERROR: 'IP Packets Error',
  DEV_STATUS_LPWAN_PACKETS_UL_ERROR: 'LPWAN Packets Error',
  DEV_STATUS_LPWAN_PACKETS_DL_ERROR: 'LPWAN Packets Error',
  DEV_STATUS_SCHC_COMPRESS_ERROR: 'SCHC Compression Error',
  DEV_STATUS_SCHC_DECOMPRESS_ERROR: 'SCHC Decompression Error',
  DEV_STATUS_SCHC_FRAGMENT_ERROR: 'SCHC Fragmentation Error',
  DEV_STATUS_SCHC_DEFRAGMENT_ERROR: 'SCHC Reassembly Error',
};

const renderIcon = (statusCode: string | undefined): StatusIconT => {
  const label = statusCodeToLabel[statusCode as string] || statusCode || NEVER_SEEN;
  if (statusCode?.includes('OK') || statusCode === 'CONNECTED') {
    return { label, color: 'success' };
  }
  if (statusCode?.includes('ERROR') || statusCode === 'DISCONNECTED') {
    return { label, color: 'error' };
  }
  return { label, color: undefined }; // undefined is color grey
};
interface RenderStatusProps {
  title: string;
  status: ConnectionStatusT | undefined;
}
function RenderStatus({ title, status }: RenderStatusProps) {
  const renderStatusIcon: StatusIconT = renderIcon(status?.code || status?.status);
  return (
    <Display.CardWithIcon
      icon={(
        <IconButton style={{ cursor: 'default' }} color={renderStatusIcon.color}>
          <CircleIcon color={renderStatusIcon.color} />
        </IconButton>
      )}
      iconTooltip={`'${renderStatusIcon?.label}'${status?.timestamp ? ` since ${formatDateFromNow(status?.timestamp)}` : ''}`}
      name={title}
      value={status?.timestamp ? datePrettyDisplay(status?.timestamp) : undefined}
      width="50rem"
    />
  );
}

export default RenderStatus;
